export default import.meta.ROLLDOWN_FILE_URL_6TiACiW9CqVWRVif5UQhwg